import { createSelector } from '@reduxjs/toolkit'
import type { AppState } from '@shared-core/store/types'
import type { MobileConfig } from '../models/config'
import { storeKey } from '../slice'

const selectConfigState = (state: AppState) => state[storeKey]

export const selectedConfigCountries = createSelector(selectConfigState, (state) => state.countries)
export const selectedConfigCountry = createSelector(selectConfigState, (state) => state.countryConfig)
export const selectedConfigVcardLimits = createSelector(selectConfigState, (state) => state.vcardLimits)
export const selectedConfigVcardLimitsStatus = createSelector(selectConfigState, (state) => state.vcardLimitsStatus)
export const selectedAppConfig = createSelector(selectConfigState, (state) => state.appConfig as MobileConfig)
export const selectedGlobalConfig = createSelector(selectConfigState, (state) => state.globalConfig)
export const selectedGlobalConfigStatus = createSelector(selectConfigState, (state) => state.globalConfigStatus)

// Пока бэк не отдаёт documentCountriesLimit в глобальном конфиге
const DEFAULT_DOCUMENT_COUNTRIES_LIMIT = 3

// Сколько стран документа можно добавить в верификации
export const selectedDocumentCountriesLimit = createSelector(
  selectedGlobalConfig,
  (globalConfig) => globalConfig?.documentCountriesLimit ?? DEFAULT_DOCUMENT_COUNTRIES_LIMIT,
)
// Legacy 2FA: тумблер нового флоу 2FA при логине. По умолчанию false — legacy локальный флоу.
export const selectedIsNew2FaFlowEnabled = createSelector(
  selectedGlobalConfig,
  (config) => config?.isNew2FaFlowEnabled ?? false,
)

// Новая схема онрампа: тоггл и лимиты по классам (обычный / VIP)
export const selectedIsOnrampV2Enabled = createSelector(
  selectedGlobalConfig,
  (config) => config?.onrampV2Enabled ?? false,
)
export const selectedOnrampLimits = createSelector(selectedGlobalConfig, (config) => config?.onrampLimits)

export const selectedPayoutLimits = createSelector(selectedGlobalConfig, (config) => config?.payoutLimits)
